<template>
	<el-dialog
		title="编辑公式"
		:visible.sync="isShow"
		:show-close="false"
		width='800px'
		:close-on-click-modal="false"
		class="default-dialog report-dialog">
		<el-form ref="form" :inline="true" :model="form">
			<el-form-item label="因素类型：">
				<el-select v-model="form.isparen" size="mini" class="symbol-select" @change='handleOptionChange'>
					<el-option
						v-for="item in options.isparen"
						:key="item.value"

						:label="item.label"
						:value="item.value">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item v-if="form.isparen == '0'" label="科目名称：">
				<el-select v-model="form.subjectCode" size="mini" filterable placeholder="请选择">
					<el-option
						v-for="item in options.objestData"
						:key="item.name"
						:label="item.labels"
						:value="item.name">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item v-else label="报表名称：">
				<el-select v-model="form.parentId" size="mini" filterable placeholder="请选择">
					<el-option
						v-for="item in options.project"
						:key="item.id"
						:label="item.name"
						:value="item.id">
					</el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="运算符号：">
				<el-select v-model="form.symbol" size="mini" class="symbol-select">
					<el-option
						v-for="item in options.symbol"
						:key="item.value"
						:label="item.label"
						:value="item.value">
					</el-option>
				</el-select>
			</el-form-item>


			<el-form-item label="取数规则：" size="mini">
				<el-select v-model="form.direction" class="regulation-select">
					<el-option
						v-for="item in options.regulation"
						:key="item.value"
						:label="item.label"
						:value="item.value">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-button
					class='minButton'
					size="mini"
					@click="addTableRowData">
					添加
				</el-button>
			</el-form-item>
		</el-form>
    <el-tabs v-if="datas.shows" v-model="tabsVal" @tab-click="tabChanges">
      <el-tab-pane label="限定性" name="qualified">
        <!-- 表格 -->
        <public-table :table="tableData">
        	<template slot-scope="props" slot="operation">
        		<template v-if="props.scope.row.id" v-for="item in tableData.operation.data">
        			<el-button
        				type="text"
        				:class="{'red': item.value == 'delete'}"
        				v-text="item.label"
        				@click.native.stop="handleOperation(item.value, props.scope.row)">
        			</el-button>
        		</template>
        	</template>
        </public-table>
      </el-tab-pane>
      <el-tab-pane label="非限定性" name="unqualified">
        <!-- 表格 -->
        <public-table :table="tableData">
        	<template slot-scope="props" slot="operation">
        		<template v-if="props.scope.row.id" v-for="item in tableData.operation.data">
        			<el-button
        				type="text"
        				:class="{'red': item.value == 'delete'}"
        				v-text="item.label"
        				@click.native.stop="handleOperation(item.value, props.scope.row)">
        			</el-button>
        		</template>
        	</template>
        </public-table>
      </el-tab-pane>
    </el-tabs>
		<!-- 表格 -->
		<public-table v-else :table="tableData">
			<template slot-scope="props" slot="operation">
				<template v-if="props.scope.row.id" v-for="item in tableData.operation.data">
					<el-button
						type="text"
						:class="{'red': item.value == 'delete'}"
						v-text="item.label"
						@click.native.stop="handleOperation(item.value, props.scope.row)">
					</el-button>
				</template>
			</template>
		</public-table>
		<div slot="footer" class="dialog-footer">
	    	<el-button size="small" class='minButton' @click="isShow = false">确 定</el-button>
	  	</div>
	</el-dialog>
</template>

<script>
import publicTable from '@/components/publicTable'

export default {
	props: {
		dialogVisible: {
			type: Boolean,
			default: false
		},
		showRegulation: {
			type: Boolean,
			default: false
		},
		prosetId:{
			type:Number,
			default:''
		},
		datas: {
			type: Object,
			default () {
				return {
					reportFormTemplateId: '',
					style: '1'
				}
			}
		}
	},
	components: {
		publicTable
	},
	data () {
		return {
      tabsVal:'qualified',
      tableDataNews:{},

			form: {
				reportFormTemplateId: '',			// 主id
				symbol: '+',	// 运算符号
				isparen:'0',
				direction: '1',	// 运算取值
				subjectCode: '',			// 科目id（如果传了资产负债id 就不能传科目id）
				parentId: ''			// 资产负债id
			},
			options: {
				symbol: [{
					value: '+',
					label: '+'
				},{
					value: '-',
					label: '-'
				}],
				isparen: [{
					label: '科目',
					value: '0'
				},{
					label: '报表',
					value: '1'
				}],
				regulation: [{
					label: '余额',
					value: '1'
				},{
					label: '借方发生',
					value: '2'
				},{
					label: '贷方发生',
					value: '3'
				},{
					label: '发生金额',
					value: '4'
				},{
					label: '实际损益额',
					value: '5'
				},{
					label: '初始余额',
					value: '6'
				},{
					label: '最终余额',
					value: '7'
				},{
					label: '借方余额',
					value: '9'
				},{
					label: '贷方余额',
					value: '10'
				}],
				project: [],
				objestData: []
			},
			tableData: {
				Maxheight: 400,				// 限定高度
				isNotSuspensionShow: true,  // 不显示悬浮效果
				border: true,				// 是否带有纵向边框
				stripe: true,				// 是否带有斑马纹
				loading: false,				// 是否显示加载动画
				hasSelect: false,			// 是否显示多选
				hasOperation: false,		// 是否有操作功能
				hasContextmenu: false,		// 是否有右键功能
				hasShowSummary: false,		// 是否显示合计行
				hasShowPagination: false,	// 是否显示分页
				config: [{
					label: '科目编码',
					value: 'subjectCode',
					show: 'normal'
				},{
					label: '报表id',
					value: 'parentId',
					show: 'normal'
				},{
					label: '报表名称',
					value: 'parentName',
					show: 'normal'
				},{
					label: '运算符号',
					value: 'symbol',
					width: 80,
					show: 'normal'
				},{
					label: '取数规则',
					value: 'direction',
					show: 'normal'
				},{
					label: '因素类别',
					value: 'isparen',
					show: 'normal',
					formatter: this.formatters
				},{
					label: '操作',
					value: 'operation',
					show: 'template'
				}],
				data: [],
				operation: {
					label: '操作',
					value: 'operation',
					data: [{
						label: '删除',
						value: 'delete'
					}]
				},
				page: {
					pageNo: 1,
					pageSize: 20,
					count: 10
				},
				center: {
					textAlign: 'center'
				}
			},
			isShow: false,
			isRefresh: false
		}
	},
	methods: {
    //tab 事件
    tabChanges(val){
      const _=this;
      console.log(val.name);
      this.tableData.data = this.tableDataNews[val.name+'s'];
    },
		// 查询所有科目
		getAllSubject () {
			this.$http.post('subject/getAllSujectTemplateByContent' , {prosetId:this.datas.prosetId}).then(res=>{
				if(res && res.data.code == 1) {
					this.options.objestData = res.data.data;
					if(this.options.objestData.length) {

						this.options.objestData.forEach(i=>{
							i.labels = i.code+'_'+i.name;
						})
					}


				}
			})
		},
		// 数据格式化
		formatters (row, column) {
			switch(row.isParen){
				case '0':
					return '科目';
					break;
				case '1':
					return '报表';
					break;
				default :
					return '未知';
					break;
			}
		},
		// 获取算法表数据
		getData () {
      this.tabsVal = 'qualified';
			let params = {
				reportFormTemplateId: this.datas.reportFormTemplateId,
			}
			try {
        let url = 'reportFormTemplate/getReportFromSecondaryTemplate';
				this.tableData.loading = true;
				this.$http.post(url,params).then(res=>{
					this.tableData.loading = false;
					if(res) {
            if(this.datas.shows){
              this.tableDataNews = res.data.data;
              this.tableData.data = res.data.data.qualifieds;
            }else{
              this.tableData.data = res.data.data;
            }
					}
				})
			}catch(e) {
				this.tableData.loading = false;
			}

		},
		// 查询资产负债表报表名称
		getAllReportFormsTemplateData () {
			this.$http.post('reportFormTemplate/getAllReportFormsTemplate',{prosetId:this.datas.prosetId}).then(res=>{
				if(res){
					if(res.data.data.length) {
						this.options.project = res.data.data;
					}
				}
			})
		},
		// 因素类型切换方法
		handleOptionChange(item) {
			if( item == 0 && !this.options.objestData.length) {
				this.getAllSubject();
			}else if(item == 1 && !this.options.project.length) {
				this.getAllReportFormsTemplateData();
			}
		},
		// 添加算法表数据
		addTableRowData () {			
			if(!this.form.subjectCode && this.form.isparen==0) {
				return this.$message.error('科目名称不能为空！');
			}else if(!this.form.parentId &&　this.form.isparen==1) {
				return this.$message.error('报表名称不能为空！');
			}else {
				if(this.form.subjectCode && this.form.isparen==0){
					this.form.parentId="";
				}else if(this.form.parentId && this.form.isparen==1) {
					this.form.subjectCode="";
				}
				this.form.reportFormTemplateId = this.datas.reportFormTemplateId;
        if(this.datas.shows){
          this.form.attribute = this.tabsVal;
        };
				this.$http.post('reportFormTemplate/savaReportFormSecondaryTemplate' , this.form).then(res=>{
					if(res) {
            if(this.datas.shows){
              this.tableDataNews[this.tabsVal+'s'] = res.data.data;
            }
            this.tableData.data = res.data.data;
						this.$message.success('添加成功！')
					}

				})
			}

		},
		// 表格操作
		handleOperation (methods, row) {
			switch (methods) {
				case 'delete':
					this.handleDelete(row);
					break;
			}
		},
		// 删除
		async handleDelete (row) {
			let params = {
				reportFormSecondaryTemplateid: row.id,
			}
			await this.$confirm(`确定删除该条数据吗？`, '提示', {
					type: 'warning',
					closeOnClickModal: false
			}).then(() => {
				this.$http.post('reportFormTemplate/delReportFromSecondaryTemplate' , params).then(res=>{
					if(res) {
						this.getData();
						this.$message.success('删除成功！')
					}

				})
			}).catch(() => {

			})
		}
	},
	watch: {
		dialogVisible (val) {
			if (val) {
				this.isShow = val;
				this.form = Object.assign({}, this.form, this.$options.data().form);
				this.$nextTick(() => {
//					this.tableData.config.forEach(item => {
//						if (item.value == 'direction') {
//							item.show = this.data.style === '1' && this.showRegulation ? 'normal' : false;
//						}
//					})
					this.getData();
					this.form.isparen == '1' && this.getAllReportFormsTemplateData();
					this.form.isparen == '0' && this.getAllSubject();

				})
			}
		},
		isShow (val) {
			if (val) {
				this.isRefresh = false;
			} else {
				this.$emit('onRefresh', this.isRefresh);
			}
			this.$emit('onShowDialog', val);
		},
		data: {
			handler (newVal, oldVal) {
				this.form = Object.assign({}, this.form, {
					reportFormTemplateId: newVal.reportFormTemplateId,
				})
			},
			deep: true
		}
	}
}
</script>
<style lang='less'>
	.report-dialog {
			.el-dialog {
				width: 800px;
			}
			.el-form-item {

			}
			.symbol-select {
				width: 80px;
			}
			.regulation-select {
				width: 100px;
			}
			.grid-wrap thead th, .grid-wrap .el-table thead.is-group th {
				background-color: #F0F3F6;
				color:#ddd;
			}
			.grid-wrap .el-table th, .grid-wrap .el-table th.is-leaf, .grid-wrap .el-table--border th.gutter:last-of-type {
				border-color: #EAEFF4;
			}
			.dialog-footer {
				text-align: right;
			}
	}
</style>



// WEBPACK FOOTER //
// src/components/dialog/superReportDialogs.vue